import React from "react";
import { withRouter } from "react-router-dom";
import Layout from "../layouts/Layout";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import * as moment from "moment";
import "../styles/InvoicePdf.css";
import { primaryShade1, grey, red, white, black } from "../styles/color";
import DownloadPdfButton from "../components/DownloadPDFButton";
import Fab from "@material-ui/core/Fab";

let platform = "other";

if (window.cordova && window.device.platform === "iOS") {
  platform = "ios";
}

class InvoicePDF extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      customersList: [],
      invoicedDealsId: [],
      invoiceNumber: "",
      invoiceDate: "",
      invoiceAmount: "",
      invoiceId: "",
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ]
    };
  }
  componentWillMount() {
    let random = Math.floor(Math.random() * (+1000 - +1)) + +1;
    this.setState({ random });
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData = whichProps => {
    let unPaidInvoices = whichProps.unPaidInvoices;
    const invoicedDealsId = [];
    let invoiceNumber = "";
    let invoiceDate = "";
    let invoiceAmount = "";
    let invoiceId = "";
    whichProps.unPaidInvoices.length > 0
      ? unPaidInvoices.map(dealsId => {
          dealsId.dealsId.map(data => invoicedDealsId.push(data));
          invoiceNumber = dealsId.invoiceNumber;
          invoiceDate = dealsId.invoiceDate;
          invoiceAmount = dealsId.invoiceAmount;
          invoiceId = dealsId.id;
          return {
            invoicedDealsId,
            invoiceNumber,
            invoiceDate,
            invoiceAmount,
            invoiceId
          };
        })
      : console.log("No Invoices Generated Yet");
    this.setState({
      invoicedDealsId,
      invoiceNumber,
      invoiceDate,
      invoiceAmount,
      invoiceId
    });
  };

  getDateValueNumber = dateValue => {
    let recievedDateType = typeof dateValue;
    let currentDate =
      recievedDateType === "object"
        ? dateValue.toDate()
        : moment(dateValue).toDate();
    let date = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let year = currentDate.getFullYear();

    let dateMonthYear = date + "-" + month + "-" + year;
    return dateMonthYear;
  };
  render() {
    const {
      invoicedDealsId,
      invoiceAmount,
      invoiceDate,
      invoiceNumber,
      invoiceId
    } = this.state;
    const {
      allCustomers,
      products,
      invoicePrintData,
      customersList
    } = this.props;
    return (
      <Layout
        position="static"
        bottomNavigation={false}
        appBar
        appBarTitle="Invoice Preview"
        appBarLeftIcon={true}
        appBarRightIcon={true}
        selectedValue={1}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 66px)",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            position: "absolute",
            top: "66px"
          }}
        >
          <div
            className="innerContainer"
            id={invoiceId}
            style={{
              transform: "scale(0.6)",
              display: "flex",
              height: "842px",
              width: "595px",
              // fontSize: "0.6em",
              flexDirection: "column",
              padding: "3px"
            }}
          >
            <div>
              <div
                style={{
                  backgroundColor: "black",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%"
                }}
              >
                {invoicePrintData.companyName
                  ? invoicePrintData.companyName
                  : "no data"}
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {invoicePrintData.companyAddress
                  ? invoicePrintData.companyAddress
                  : "no data"}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%"
                }}
              >
                <div>
                  {invoicePrintData.stdCode
                    ? "Phone:(Off.) " + invoicePrintData.stdCode
                    : " "}{" "}
                  {invoicePrintData.offPhone1
                    ? " -, " + invoicePrintData.offPhone1
                    : ""}
                  {invoicePrintData.offPhone2
                    ? "," + invoicePrintData.offPhone2
                    : ""}
                  {invoicePrintData.stdCode
                    ? ", (Resi.) " + invoicePrintData.stdCode
                    : " "}{" "}
                  {invoicePrintData.residencePhone
                    ? " - " + invoicePrintData.residencePhone
                    : ""}{" "}
                  {invoicePrintData.stdCode
                    ? "Fax : " + invoicePrintData.stdCode
                    : ""}{" "}
                  {invoicePrintData.faxNumber
                    ? " - " + invoicePrintData.faxNumber
                    : " "}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%"
                }}
              >
                BROKERS IN :
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                {products.toString()}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  border: "0.5px solid black",
                  // padding: platform === "ios" ? null : "5px",
                  width: "100%"
                }}
              >
                <div
                  style={{
                    flex: "4",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start"
                    }}
                  >
                    M/s : {allCustomers.name}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start"
                    }}
                  >
                    Address : {allCustomers.address}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flex: "2",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <div
                    style={{
                      border: "1px solid black"
                    }}
                  >
                    INVOICE
                  </div>
                </div>
                <div
                  style={{
                    flex: "4",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end"
                    }}
                  >
                    Bill No : {invoiceNumber}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end"
                    }}
                  >
                    Date : {this.getDateValueNumber(invoiceDate)}
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                height: platform === "ios" ? null : "50vh",
                borderLeft: "1px dotted black",
                borderRight: "1px dotted black"
              }}
            >
              <div
                style={{
                  backgroundColor: grey,
                  color: white,
                  display: "flex",
                  flexDirection: "row",
                  height: platform === "ios" ? null : "5vh"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    borderRight: "0.5px dotted black",
                    flex: 1,
                    justifyContent: "center",
                    height: platform === "ios" ? null : "100%",
                    alignItems: "center",
                    fontSize: "0.6em"
                  }}
                >
                  Date
                </div>
                <div
                  style={{
                    display: "flex",
                    borderRight: "0.5px dotted black",
                    flex: 3,
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.7em"
                  }}
                >
                  Description City
                </div>
                <div
                  style={{
                    display: "flex",
                    borderRight: "0.5px dotted black",
                    flex: 2,
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.7em"
                  }}
                >
                  Goods Name / Rate
                </div>
                <div
                  style={{
                    display: "flex",
                    borderRight: "0.5px dotted black",
                    flex: 1,
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.7em"
                  }}
                >
                  Truck
                </div>
                <div
                  style={{
                    display: "flex",
                    borderRight: "0.5px dotted black",
                    flex: 1,
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.7em"
                  }}
                >
                  Bag / Truck / Wht
                </div>
                <div
                  style={{
                    display: "flex",
                    borderRight: "0.5px dotted black",
                    flex: 1,
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.7em"
                  }}
                >
                  Rate
                </div>
                <div
                  style={{
                    display: "flex",
                    borderRight: "0.5px dotted black",
                    flex: 1,
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.7em"
                  }}
                >
                  Amount
                </div>
              </div>

              {customersList.map(row => (
                <div
                  key={row.id}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    borderTop: "0.5px dotted black",
                    borderLeft: "0.5px dotted black",
                    borderBottom: "0.5px dotted black",
                    alignItems: "center",
                    height: "20px"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      borderRight: "0.5px dotted black",
                      height: platform === "ios" ? null : "100%",
                      flex: 1,
                      justifyContent: "flex-start",
                      alignItems: "center",
                      fontSize: "0.6em"
                    }}
                  >
                    {this.getDateValueNumber(row.date)}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      borderRight: "0.5px dotted black",
                      height: platform === "ios" ? null : "100%",
                      flex: 3,
                      justifyContent: "flex-start",
                      alignItems: "center",
                      fontSize: "0.6em"
                    }}
                  >
                    {row.customerName}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      borderRight: "0.5px dotted black",
                      height: platform === "ios" ? null : "100%",
                      flex: 2,
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "0.6em"
                    }}
                  >
                    {row.products} / {row.rate}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      borderRight: "0.5px dotted black",
                      height: platform === "ios" ? null : "100%",
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "0.6em"
                    }}
                  >
                    {row.truckTrollaQuantity ? row.truckTrollaQuantity : 0}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      borderRight: "0.5px dotted black",
                      height: platform === "ios" ? null : "100%",
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "0.6em"
                    }}
                  >
                    {row.quantity}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      borderRight: "0.5px dotted black",
                      height: platform === "ios" ? null : "100%",
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "0.6em"
                    }}
                  >
                    {parseInt(row.customerBrokerage)}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      borderRight: "0.5px dotted black",
                      height: platform === "ios" ? null : "100%",
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "0.6em"
                    }}
                  >
                    {parseInt(row.customerBrokerage) * parseInt(row.quantity)}
                  </div>
                </div>
              ))}
              <div
                style={{
                  height:
                    platform === "ios"
                      ? `calc(300px - (${customersList.length} * 20px))`
                      : `calc(50vh - (${customersList.length} * 20px))`
                }}
              />
            </div>

            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderTop: "0.5px dotted black",
                  borderLeft: "0.5px dotted black",
                  borderBottom: "0.5px dotted black",
                  alignItems: "center",
                  height: platform === "ios" ? null : "5vh"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: "4",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    padding: "5px 0px 5px 5px"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start"
                    }}
                  >
                    {invoicePrintData.jurisdictionDetails
                      ? invoicePrintData.jurisdictionDetails
                      : ""}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start"
                    }}
                  >
                    {invoicePrintData.bankDetails
                      ? "BANK DETAILS : " + invoicePrintData.bankDetails
                      : ""}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: "2",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    paddingRight: "5px"
                  }}
                >
                  TOTAL
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: "1",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  {invoiceAmount}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderTop: "0.5px dotted black",
                  borderLeft: "0.5px dotted black",
                  borderBottom: "0.5px dotted black",
                  alignItems: "center",
                  height: platform === "ios" ? null : "5vh"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: "4",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    padding: "5px 0px 5px 5px"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start"
                    }}
                  >
                    {invoicePrintData.accountNumber
                      ? "ACCOUNT NO : " + invoicePrintData.accountNumber
                      : ""}{" "}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start"
                    }}
                  >
                    {invoicePrintData.rtgsNumber
                      ? "RTGS NO : " + invoicePrintData.rtgsNumber
                      : ""}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: "2",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    paddingRight: "5px"
                  }}
                >
                  ADD
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: "1",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderTop: "0.5px dotted black",
                  borderLeft: "0.5px dotted black",
                  borderBottom: "0.5px dotted black",
                  alignItems: "center",
                  height: platform === "ios" ? null : "5vh"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: "4",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    padding: "5px 0px 5px 5px"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start"
                    }}
                  >
                    {invoicePrintData.panNumber
                      ? "PAN NO : " + invoicePrintData.panNumber
                      : " "}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: "2",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    paddingRight: "5px"
                  }}
                >
                  SUB
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: "1",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderTop: "0.5px dotted black",
                  borderLeft: "0.5px dotted black",
                  borderBottom: "0.5px dotted black",
                  alignItems: "center",
                  height: platform === "ios" ? null : "5vh"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: "4",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    padding: "5px 0px 5px 5px"
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    flex: "2",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    paddingRight: "5px"
                  }}
                >
                  NET TOTAL
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: "1",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  {invoiceAmount}{" "}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderTop: "0.5px dotted black",
                  borderLeft: "0.5px dotted black",
                  borderBottom: "0.5px dotted black",
                  alignItems: "center"
                  // height: "10vh"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: "7",
                    borderRight: "0.5px dotted black",
                    height: platform === "ios" ? null : "100%",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    padding: "5px 0px 5px 5px"
                  }}
                >
                  <div style={{ display: "flex", alignItems: "flex-end" }}>
                    {invoicePrintData.companyName
                      ? invoicePrintData.companyName
                      : ""}
                  </div>
                  <br />
                  <div style={{ display: "flex", alignItems: "flex-end" }}>
                    Auth Signature
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <Fab
              aria-label="Add"
              style={{
                position: "fixed",
                bottom: "15px",
                right: "15px",
                backgroundColor: primaryShade1
              }}
            >
              <DownloadPdfButton
                invoiceId={invoiceId}
                invoiceNumber={invoiceNumber}
              />
            </Fab>
          </div>
        </div>
      </Layout>
    );
  }
}
InvoicePDF.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withRouter(InvoicePDF);
